import React from 'react';
import { authAPI } from '../utils/api';

const LoginPage: React.FC = () => {
  const handleLogin = () => {
    authAPI.login();
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center">
      <img 
                      src="/assets/images/SagisLogo.png"   
                      alt="Logo"
                      style={{ height: '85px'}}
                      className="logo-loginpage"
      />

      {/* Background Video */}
      <video 
        className="video-background position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
        autoPlay
        muted
        playsInline
        loop
        src="https://www.sagisdx.com/wp-content/uploads/2023/04/sagis-swirl-bg-3.mp4"
      />

      <div className="container-loginpage">
        <div className='blob-section'>
          <div className='inside-blob-section'>
            <h2 className="text-loginbox">Regional Pathologist Generator</h2>
            <button 
              onClick={handleLogin}
              className="btn btn-login"
            >
              Sign In
            </button>
          </div>
        </div>
                
            
      </div>

    </div>
  );
};

export default LoginPage;
